exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobilier-form .grid {\n  -webkit-transition: all 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0ms;\n  transition: all 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0ms;\n}\n.mobilier-form .grid .grid__row {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.mobilier-form .grid .grid__row .input {\n  width: 100%;\n  margin-bottom: 2.5rem;\n}\n.mobilier-form .grid .grid__row > .headline-medium {\n  width: 100%;\n}\n.mobilier-form .grid.closed {\n  overflow: auto;\n  max-height: 0;\n}", ""]);

// exports
